import clsx from 'clsx';
import { DallasSpacing } from '../types/spacing';

import styles from './DallasDivider.module.scss';

export interface Props {
  className?: string;
  margin?: DallasSpacing;
  thickness?: 1 | 2 | 4;
  style?: 'solid' | 'dashed';
  orientation?: 'horizontal' | 'vertical';
}

export default function DallasDivider({
  className,
  margin = 'none',
  thickness = 1,
  style = 'solid',
  orientation = 'horizontal',
}: Props) {
  return (
    <hr
      role="separator"
      className={clsx(
        className,
        styles.root,
        styles[orientation],
        styles[`style_${style}`],
        styles[`thickness_${thickness}`],
        styles[`${orientation}_margin_${margin}`],
      )}
      aria-orientation={orientation}
    />
  );
}
